"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderStatusFilter = orderStatusFilter;
exports.orderTypeFilter = orderTypeFilter;
exports.paidFilter = paidFilter;
exports.payTypeFilter = payTypeFilter;
exports.refundStatusFilter = refundStatusFilter;
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

//订单过滤器

/**
 * @description 支付状态
 */
function paidFilter(status) {
  var statusMap = {
    true: '已支付',
    false: '未支付'
  };
  return statusMap[status];
}

/**
 * @description 订单状态
 * 2,已收货，待评价
 */
function orderStatusFilter(status) {
  var statusMap = {
    0: '待发货',
    1: '待收货',
    2: '已收货',
    3: '待评价',
    '-2': '已退款',
    '-1': '退款中'
  };
  return statusMap[status];
}

/**
 * @description 退款状态
 * 2,已收货，待评价
 */
function refundStatusFilter(status) {
  var statusMap = {
    0: '未退款',
    1: '申请中',
    2: '已退款',
    3: '退款中'
  };
  return statusMap[status];
}

/**
 * @description 支付方式
 */
function payTypeFilter(status) {
  var statusMap = {
    weixin: '微信',
    alipay: '支付宝',
    yue: '余额'
  };
  return statusMap[status] || '-';
}

/**
 * @description 订单类型
 */
function orderTypeFilter(status) {
  var statusMap = {
    1: '普通订单',
    2: '核销订单'
  };
  return statusMap[status];
}